import type { LinkElementValue } from '@vedalib/editor/lib/elements'
import { CONFIG_ELEMENTS } from '@vedalib/editor/lib/elements'

import { DEMO_MODE } from 'services/Store/Project/constants'
import { t } from 'services/Translation'

import DemoWrapper from '../../decorators/DemoWrapper'
import Element from './LinkElement'
import type { LinkDemoType } from './linkTypes'

const DEMO_VALUE: LinkElementValue = {
  linkLabel: t('elements.link.demo.label'),
  linkURL: undefined,
  showPreview: true,
  title: t('elements.link.placeholder.title'),
  description: t('elements.link.placeholder.description'),
  image: null,
  overlay: null,
}

const LinkDemo: LinkDemoType = ({ styles, fonts, feedback }) => {
  return (
    <DemoWrapper>
      <Element
        element={{
          id: `${CONFIG_ELEMENTS.link.type}-demo`,
          type: CONFIG_ELEMENTS.link.type,
          value: DEMO_VALUE,
          style: {},
          font: {},
          feedback: {},
        }}
        feedback={feedback}
        font={fonts}
        mode={DEMO_MODE}
        styles={styles}
      />
    </DemoWrapper>
  )
}

export default LinkDemo
